import styles from './FullHero.module.scss';
import { Button, Content, Heading, Link } from '@wienenergiegithub/ui-next';
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const FullHero = ({
  background,
  handleClick,
  image,
  interactionId,
  link,
  secondaryInteractionId,
  secondaryLink,
  showDimmed,
  subtitle,
  title,
}) => (
  <div className={styles.container}>
    {!!background && <div className={styles[background]} />}
    <div
      className={classNames(styles.backgroundImage, {
        [styles.dimmedImage]: showDimmed,
      })}
      style={{
        backgroundImage: `url(${image.src})`,
      }}
    />
    <div className={styles.content}>
      {!!title && (
        <Heading as="h1" className={styles.title}>
          {title}
        </Heading>
      )}
      {!!subtitle && (
        <Content className={styles.subtitle} theme="contrast" withParser>
          {subtitle}
        </Content>
      )}
      {!!link && (
        <div className={styles.buttonContainer}>
          <Button
            isElevated
            onClick={handleClick(interactionId)}
            render={<Link target={link.target} to={link.url} />}
            theme="ghost"
          >
            {link.title}
          </Button>
          {!!secondaryLink && (
            <Button
              isElevated
              onClick={handleClick(secondaryInteractionId)}
              render={
                <Link target={secondaryLink.target} to={secondaryLink.url} />
              }
              theme="ghost"
            >
              {secondaryLink.title}
            </Button>
          )}
        </div>
      )}
    </div>
  </div>
);

FullHero.propTypes = {
  background: PropTypes.string,
  handleClick: PropTypes.func,
  image: PropTypes.shape({
    height: PropTypes.number,
    src: PropTypes.string.isRequired,
    srcSet: PropTypes.string,
    title: PropTypes.string,
    width: PropTypes.number,
  }).isRequired,
  interactionId: PropTypes.string,
  link: PropTypes.shape({
    target: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
  }),
  secondaryInteractionId: PropTypes.string,
  secondaryLink: PropTypes.shape({
    target: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
  }),
  showDimmed: PropTypes.bool,
  subtitle: PropTypes.string,
  title: PropTypes.string,
};

export default FullHero;
